import Account from "@/helper/AccountHelper.js";
import ConfigManager from '@/config/ConfigManager.js'
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import { AccountStatusModel } from '../model/AccountLoginModel';

export default {
    /**
     * @param {string} contactNumber
     */
     checkAccountLoginStatus: function (contactNumber) {
        let params = {
            contact_number: contactNumber
        };
        let url = ConfigManager.getApiModuleUrl() + '/auth/check_pin';
        return BzbsApi.connectBzbsPost(url, null, params).pipe(map((res) => {
            let account = new AccountStatusModel();
            account.setDataFromApi(res.data.data);
            return account;
        }));
    },

    /**
     * @param {ChangePasswordPinModel} params /module/Login/model/AccountLoginModel.js
     */
    changePasswordPin: function (params) {
        let url = ConfigManager.getApiModuleUrl() + '/auth/change_pin';
        return BzbsApi.connectBzbsPost(url, null, params).pipe(map((res) => {
            return res.data;
        }));
    },

    syncCart: function (userskip) {
        let token = Account.getToken();
        let params = {
            token: token,
            skip_userid: userskip
        };
        let url = ConfigManager.getApiModuleUrl() + '/profile/' + Account.getUserId() + '/sync';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    }
}
